import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ServiceOrders } from '../serviceorder.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Users } from 'src/app/options/users/users.model';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { ServiceordersService } from '../serviceorders.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Globle } from 'src/assets/globle';
import { OptionService } from 'src/app/options/option.service';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialog } from '@angular/material/dialog';
import { map, startWith } from 'rxjs/operators';
import { ServiceOrderFields } from '../serviceorderfields.model';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-serviceorders',
  templateUrl: './serviceorders.component.html',
  styleUrls: ['./serviceorders.component.css'],
  queries: {
    contentRef: new ViewChild("ModalView"),
    contentRef1: new ViewChild("ModalConfirmReject"),
  },
})
export class ServiceordersComponent implements OnInit {

  serviceOrdersList: ServiceOrders[] = [];
  displayedColumns: string[] = ['id', 'date', 'userFullName', 'subServiceName', 'action'];
  displayedColumnsOrderValue: string[] = ['label', 'value', 'copy'];
  dataSource!: MatTableDataSource<ServiceOrders>;
  dataSourceOrderValue!: MatTableDataSource<ServiceOrderFields>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false;

  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;

  serviceOrders: ServiceOrders = {} as ServiceOrders;

  chargedStatus: { id: number, name: string }[] = [{ id: -1, name: "all" }, { id: 1, name: "تم التنفيذ" },
  { id: 0, name: "قيد التنفيذ" }, { id: 2, name: "مرفوض" }];
  selectedStatus: number = 0;


  imgView!: string;
  rejectReason: string = "";
  id: any;
  pageSize = 100;
  userLoginId!: string;
  users: Users[] = [];
  userControl = new FormControl();
  filteredOptions!: Observable<any[]>;
  selectedUserId: string = "";
  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;

  amount = 0;

  constructor(private service: ServiceordersService,
    private snackBar: MatSnackBar,
    private globle: Globle,
    private optionService: OptionService,
    private localStorage: LocalStorageService,
    private clipboard: Clipboard,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.userLoginId = this.localStorage.retrieve("userInfo").userId
    this.getUsers();


  }

  ngAfterViewInit(): void {
    this.getServiceOrders();
    //  setInterval(() => { this.getDirectCharge(); }, 180000);
  }

  getUsers() {
    let userId = this.localStorage.retrieve("userInfo").userId
    this.optionService.getAllCustomers(userId).subscribe(data => {
      this.users = data;
      this.autoCompleatFilter();
    }, error => {
      console.log(error)
    })
  }

  displayFn(user: Users): string {
    //return user && user.userName || user.fullName ? user.userName || user.fullName : '';
    return user != null ? (user.userName != null && user.fullName != null) ?
      (user.userName + " - " + user.fullName) : user.fullName != null ? user.fullName :
        user.userName != null ? user.userName : "" : "";
  }

  autoCompleatFilter() {
    this.filteredOptions = this.userControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value != null ? value.name : ""),
        map(name => name ? this._filter(name) : this.users.slice())
      );
  }

  private _filter(name: string): Users[] {
    const filterValue = name.toLowerCase();

    return this.users.filter(option => option.userName.indexOf(filterValue) === 0 || option.fullName.toLowerCase().indexOf(filterValue) === 0);
  }

  selectUserChange(value: any) {
    this.selectedUserId = value.id;
  }

  getServiceOrders() {
    this.spinnerOverlay = true;

    this.service.get(this.selectedStatus, this.selectedUserId, this.fromDate.nativeElement.value,
      this.toDate.nativeElement.value).subscribe(data => {
        console.log(data)
        this.serviceOrdersList = data.sort((n1, n2) => n2.id - n1.id);
        this.dataSource = new MatTableDataSource(this.serviceOrdersList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinnerOverlay = false;
      },
        error => {
          this.spinnerOverlay = false;
          console.log(error);
        })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  edit(item: any) {
    // this.message_text = item.message;
    // this.openDialogView();
  }

  onSearch() {
    this.getServiceOrders();
  }

  clearUser() {
    this.selectedUserId = "";
    this.userControl.reset();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialogOrderFields(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '400px',
    });
  }

  // openDialogView(): void {
  //   const dialogRef = this.dialog.open(this.contentRef1, {
  //     width: '500px',
  //   });
  // }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  openDialogReject(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '250px',
      height: '250px'
    });
  }

  onDone(item: ServiceOrders) {
    this.spinnerOverlay = true;
    this.serviceOrders = item;
    var obj = {
      id: item.id,
      status: 1,
      rejectReason: "",
      compleateBy: this.userLoginId
    }
    this.service.updateStatus(obj).subscribe(data => {
      this.createPermNotification(this.serviceOrders.subServiceName,
        " تم تنفيذ الطلب رقم  " + this.serviceOrders.id);
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getServiceOrders();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("حدث خطأ بالنظام", "snackBarError");
        }
      })

  }

  onReject(item: ServiceOrders) {
    this.rejectReason = "";
    this.serviceOrders = item;
    this.openDialogReject();
  }

  confirmReject() {
    this.spinnerOverlay = true;

    var obj = {
      id: this.serviceOrders.id,
      status: 2,
      rejectReason: this.rejectReason,
      compleateBy: this.userLoginId
    }

    this.service.updateStatus(obj).subscribe(data => {
      this.createPermNotification(this.serviceOrders.subServiceName,
        " تم رفض الطلب رقم " + this.serviceOrders.id +
        "- (سبب الرفض : " + this.rejectReason + ")");
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getServiceOrders();
      this.dialog.closeAll();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("حدث خطأ بالنظام", "snackBarError");
        }
      })
  }

  openSnackBarCopy(playerId: string) {
    this.snackBar.open("تم نسخ  " + playerId, 'Close', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: "snackBarSuccess"
    });
  }

  viewFields(row: ServiceOrders) {
    this.serviceOrders = row;
    this.openDialogOrderFields();
    this.dataSourceOrderValue = new MatTableDataSource(row.subServiceFieldsResponses);
  }

  createPermNotification(permNotfbody: string, pushNotifBody: string) {
    var obj =
    {
      "title": permNotfbody,
      "message": pushNotifBody,
      "usersIds": [this.serviceOrders.userId],
      "createBy": this.userLoginId,
      "playerId": ""
    }

    this.optionService.createPermNotifications(obj).subscribe(data => {
      this.sendNotification(this.serviceOrders.fcmToken, pushNotifBody);
    }, error => {
      console.log(error);
    })
  }

  sendNotification(fcmToken: string, body: string) {

    var obj = {
      "fcmToken": fcmToken,
      "title": " طلب خدمات ",
      "body": body
    }

    this.optionService.sendPushNotification(obj).subscribe(data => {
      console.log(data)
    },
      error => {
        console.log(error)
        this.openSnackBar(error, 'snackBarError');
        this.spinnerOverlay = false;
      })
  }

  copy(value: string) {
    this.clipboard.copy(value);
    this.openSnackBarCopy(value);
  }
}
